
import Aos from "../../components/aos/aos";
import { Link } from "react-router-dom";
import { useEffect } from 'react';
const About = () => {
    useEffect(() => {
        Aos(1000)
    }, [])
    return (
        <div className="w-full  mt-4 rounded-lg bg-white/30 backdrop-blur shadow-md shadow-white h-auto py-4 px-4 flex flex-col space-y-4 justify-center items-center">
            <div className="text-3xl font-extrabold font-mono text-white" data-aos="fade-down">WHO <span className='text-yellow-300'>I</span> AM</div>
            <div className="text-xl text-white font-sans md:px-8 text-justify" data-aos="zoom-in">I am Otsu Udoka, a dedicated and experienced full-stack web developer/programmer. I have a proven track record of delivering high-quality and
                scalable web solutions that meet the unique needs of clients. My proficiency in front-end technologies like HTML and CSS allows me to create visually appealing and user-friendly interfaces.
                I specialize in React for building interactive and dynamic user experiences, and my back-end skills include PHP and Laravel for robust server-side development,
                coupled with MySQL for efficient database management. </div>
                <Link reloadDocument data-aos="fade-up" to="/about" className='bg-yellow-500 px-2 py-2 text-white font-bold rounded-lg justify-self-start'>Read More</Link>
        </div>
    );
}

export default About;